export default __webpack_public_path__ + "static/media/2324 cutlery top.dc5e80f2.png";